exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-footer,.fixed-header{width:100%;position:fixed;background:#000;padding:15px 30px;z-index:1}.fixed-footer{bottom:0}@media (min-width:768px){.tx-inline-block{display:inline-block}}@media (max-width:600px){.fixed-footer,.fixed-header{padding:5px 10px}.fixed-footer .btn--green-ad{font-size:12px;padding:4px 12px}.mr-8{margin-right:.1rem}.tx-18{font-size:1rem}}@media (max-width:320px){.tx-18,.tx-white{font-size:14px}}", ""]);

// exports
